export const NY = "America/New_York";

const parts = (date) => {
  const p = new Intl.DateTimeFormat("en-US", { timeZone: NY, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(date);
  const g = (k) => Number(p.find((x) => x.type === k).value);
  return { y: g("year"), mo: g("month"), d: g("day"), h: g("hour") % 24, mi: g("minute"), s: g("second") };
};

const nyOffsetMs = (date) => { const t = parts(date); return Date.UTC(t.y, t.mo - 1, t.d, t.h, t.mi, t.s) - Math.floor(date.getTime() / 1000) * 1000; };

export const etLocalToIso = (local) => {
  if (!local) return null;
  const naive = new Date(`${local}:00Z`);
  const guess = new Date(naive.getTime() - nyOffsetMs(naive));
  return new Date(naive.getTime() - nyOffsetMs(guess)).toISOString();
};

export const isoToEtLocal = (iso) => (iso ? new Date(new Date(iso).getTime() + nyOffsetMs(new Date(iso))).toISOString().slice(0, 16) : "");

export const tomorrowLaunchLocal = () => {
  const t = parts(new Date());
  const d = new Date(Date.UTC(t.y, t.mo - 1, t.d + 1));
  return `${d.toISOString().slice(0, 10)}T00:01`;
};

export const formatEt = (iso) => (iso ? new Intl.DateTimeFormat("en-US", { timeZone: NY, weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }).format(new Date(iso)) : "");
